import { Box, Typography, Button, CircularProgress } from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
// ★cmd-po_1206 (T4-b): frame Dialog→PoModalShell / footer→PoButton へ移行
import { PoModalShell } from "./common/PoModalShell";
import { PoButton } from "./common/PoButton";
import { Link } from "react-router-dom";
import { DashboardDailyDetailResponse } from "../api/dashboard";
import { dataDifine } from "../config/dataInterface";

interface S2DayDetailModalProps {
  open: boolean;
  onClose: () => void;
  date: string;
  loading: boolean;
  data: DashboardDailyDetailResponse | null;
  entries: dataDifine[];
  entriesTotal: number;
  tossUps: dataDifine[];
  tossUpsTotal: number;
  isEntryAnalysisAvailable: boolean;
  isClosingAvailable: boolean;
  onOpenEntryDetail: () => void;
  hasHopeCallDateSearch: boolean;
}

export function S2DayDetailModal({
  open,
  onClose,
  date,
  loading,
  data,
  entries,
  entriesTotal,
  tossUps,
  tossUpsTotal,
  isEntryAnalysisAvailable,
  isClosingAvailable,
  onOpenEntryDetail,
  hasHopeCallDateSearch,
}: S2DayDetailModalProps) {
  // ★cmd-po_1206 (T4-b): 手組み sip-foot を PoModalShell の footer スロットへ移設
  const footerNode = (
    <>
      <Box
        component="span"
        className="draft-note"
        sx={{ mr: "auto", fontSize: "var(--fs-11)", color: "var(--color-sumi-muted)" }}
      />
      <PoButton variant="secondary" size="small" onClick={onOpenEntryDetail}>
        この日の一覧を開く（{date}で絞り込み）
      </PoButton>
      <PoButton variant="primary" size="small" onClick={onClose}>
        閉じる
      </PoButton>
    </>
  );

  return (
    <PoModalShell
      open={open}
      title={`${date} の実績`}
      onClose={onClose}
      widthPx={640}
      testidPrefix="dashboard-day-detail"
      frameTestId="dashboard-day-detail-dialog"
      bodySx={{ gap: "var(--sp-3)" }}
      footer={footerNode}
    >
        {loading ? (
          <Box sx={{ py: 4, textAlign: "center" }}>
            <CircularProgress size={24} />
          </Box>
        ) : data ? (
          <>
            {/* KPIグリッド .sx6: grid 4 cols */}
            <Box sx={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "var(--sp-2)" }}>
              {isEntryAnalysisAvailable && (
                <>
                  <Box
                    className="rs-count"
                    sx={{
                      border: "1px solid var(--color-border)",
                      borderRadius: "var(--radius-sm)",
                      p: "var(--sp-3) var(--sp-2)",
                      display: "flex",
                      flexDirection: "column",
                      gap: "var(--sp-05)",
                    }}
                  >
                    <Typography component="span" className="l" sx={{ fontSize: "var(--fs-11)", color: "var(--color-sumi-muted)" }}>エントリー（ショット）</Typography>
                    <Typography component="span" className="n" sx={{ fontWeight: "var(--fw-bold)", fontSize: "var(--fs-19)", color: "var(--color-ai)" }}>{data.entry_number_shot}</Typography>
                    <Typography component="span" className="l" sx={{ fontSize: "var(--fs-11)", color: "var(--color-sumi-muted)" }}>開通: {data.entry_shot_open_number}</Typography>
                  </Box>
                  <Box
                    className="rs-count"
                    sx={{
                      border: "1px solid var(--color-border)",
                      borderRadius: "var(--radius-sm)",
                      p: "var(--sp-3) var(--sp-2)",
                      display: "flex",
                      flexDirection: "column",
                      gap: "var(--sp-05)",
                    }}
                  >
                    <Typography component="span" className="l" sx={{ fontSize: "var(--fs-11)", color: "var(--color-sumi-muted)" }}>エントリー（ストック）</Typography>
                    <Typography component="span" className="n" sx={{ fontWeight: "var(--fw-bold)", fontSize: "var(--fs-19)", color: "var(--color-ai)" }}>{data.entry_number_stack}</Typography>
                    <Typography component="span" className="l" sx={{ fontSize: "var(--fs-11)", color: "var(--color-sumi-muted)" }}>開通: {data.entry_stack_open_number}</Typography>
                  </Box>
                </>
              )}
              <Box
                className="rs-count"
                sx={{
                  border: "1px solid var(--color-border)",
                  borderRadius: "var(--radius-sm)",
                  p: "var(--sp-3) var(--sp-2)",
                  display: "flex",
                  flexDirection: "column",
                  gap: "var(--sp-05)",
                }}
              >
                <Typography component="span" className="l" sx={{ fontSize: "var(--fs-11)", color: "var(--color-sumi-muted)" }}>トスアップ数</Typography>
                <Typography component="span" className="n" sx={{ fontWeight: "var(--fw-bold)", fontSize: "var(--fs-19)", color: "var(--color-ai)" }}>{data.toss_up_number}</Typography>
                <Typography component="span" className="l" sx={{ fontSize: "var(--fs-11)", color: "var(--color-sumi-muted)" }}>有効アポ: {data.toss_up_valid_appoint_number}</Typography>
              </Box>
              {isClosingAvailable && (
                <Box
                  className="rs-count"
                  sx={{
                    border: "1px solid var(--color-border)",
                    borderRadius: "var(--radius-sm)",
                    p: "var(--sp-3) var(--sp-2)",
                    display: "flex",
                    flexDirection: "column",
                    gap: "var(--sp-05)",
                  }}
                >
                  <Typography component="span" className="l" sx={{ fontSize: "var(--fs-11)", color: "var(--color-sumi-muted)" }}>クロージング-有効アポ数</Typography>
                  <Typography component="span" className="n" sx={{ fontWeight: "var(--fw-bold)", fontSize: "var(--fs-19)", color: "var(--color-ai)" }}>{data.closing_appoint_number}</Typography>
                  <Typography component="span" className="l" sx={{ fontSize: "var(--fs-11)", color: "var(--color-sumi-muted)" }}>エントリー: {data.closing_success_number}</Typography>
                </Box>
              )}
            </Box>

            {/* 2カラム: エントリー行 + 商材別内訳 .sx9 */}
            {isEntryAnalysisAvailable && (
              <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "var(--sp-4)" }}>
                {/* 当日のエントリー .pp-sec */}
                <Box className="pp-sec" sx={{ display: "flex", flexDirection: "column", gap: "var(--sp-2)" }}>
                  <Typography
                    component="span"
                    className="pp-sec-title"
                    sx={{
                      fontSize: "var(--fs-12)",
                      fontWeight: "var(--fw-bold)",
                      color: "var(--color-ai)",
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "var(--sp-2)",
                      "&::before": {
                        content: '""',
                        width: "3px",
                        height: "12px",
                        background: "var(--color-kohaku)",
                        borderRadius: "2px",
                      },
                    }}
                  >
                    当日のエントリー（{entriesTotal > 0 ? entriesTotal : data.entry_number_shot + data.entry_number_stack}件）
                  </Typography>
                  {entries.length > 0 ? (
                    <>
                      <Box className="dd-list" sx={{ display: "flex", flexDirection: "column", gap: "var(--sp-1)" }}>
                        {entries.slice(0, 3).map((row, i) => (
                          <Box
                            key={i}
                            className="dd-row"
                            component={Link}
                            to="/contract"
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: "var(--sp-2)",
                              p: "var(--sp-1) var(--sp-2)",
                              border: "1px solid var(--color-border)",
                              borderRadius: "var(--radius-sm)",
                              fontSize: "var(--fs-12)",
                              cursor: "pointer",
                              "&:hover": { bgcolor: "action.hover" },
                              textDecoration: "none",
                              color: "inherit",
                            }}
                          >
                            <Typography component="span" className="dd-nm" sx={{ fontWeight: "var(--fw-semibold)", color: "var(--color-sumi)", flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", fontSize: "var(--fs-12)" }}>
                              {String(row.customer_name ?? row.customer_phone_number ?? "")}
                            </Typography>
                            <Typography component="span" className="dd-pd" sx={{ color: "var(--color-sumi-light)", fontSize: "var(--fs-11)", flexShrink: 0, maxWidth: 80, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                              {String(row.product_name ?? "")}
                            </Typography>
                            <ChevronRightIcon sx={{ fontSize: 14, color: "text.disabled", flexShrink: 0 }} />
                          </Box>
                        ))}
                      </Box>
                      {entriesTotal > 3 && (
                        <Typography component="span" className="po-helper" sx={{ fontSize: "var(--fs-11)", color: "var(--color-sumi-muted)" }}>
                          ほか{entriesTotal - 3}件
                        </Typography>
                      )}
                      <Button size="small" variant="outlined" sx={{ mt: 1.5, fontSize: "var(--fs-11)" }} onClick={onOpenEntryDetail}>
                        一覧で確認
                      </Button>
                    </>
                  ) : (
                    <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
                      <Box sx={{ fontSize: "var(--fs-12)", color: "text.secondary" }}>ショット: <strong>{data.entry_number_shot}</strong>件</Box>
                      <Box sx={{ fontSize: "var(--fs-12)", color: "text.secondary" }}>ストック: <strong>{data.entry_number_stack}</strong>件</Box>
                    </Box>
                  )}
                </Box>
                {/* 商材別内訳 .pp-sec */}
                <Box className="pp-sec" sx={{ display: "flex", flexDirection: "column", gap: "var(--sp-2)" }}>
                  <Typography
                    component="span"
                    className="pp-sec-title"
                    sx={{
                      fontSize: "var(--fs-12)",
                      fontWeight: "var(--fw-bold)",
                      color: "var(--color-ai)",
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "var(--sp-2)",
                      "&::before": {
                        content: '""',
                        width: "3px",
                        height: "12px",
                        background: "var(--color-kohaku)",
                        borderRadius: "2px",
                      },
                    }}
                  >
                    商材別内訳
                  </Typography>
                  <Box sx={{ fontSize: "var(--fs-11)", color: "var(--color-sumi-muted)" }}>
                    {data.entry_number_shot + data.entry_number_stack > 0
                      ? `計${data.entry_number_shot + data.entry_number_stack}件`
                      : "データなし"}
                  </Box>
                </Box>
              </Box>
            )}

            {/* 本日が架電希望日のトスアップ .pp-sec */}
            <Box className="pp-sec" sx={{ display: "flex", flexDirection: "column", gap: "var(--sp-2)" }}>
              <Typography
                component="span"
                className="pp-sec-title"
                sx={{
                  fontSize: "var(--fs-12)",
                  fontWeight: "var(--fw-bold)",
                  color: "var(--color-ai)",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "var(--sp-2)",
                  "&::before": {
                    content: '""',
                    width: "3px",
                    height: "12px",
                    background: "var(--color-kohaku)",
                    borderRadius: "2px",
                  },
                }}
              >
                本日が架電希望日のトスアップ（{tossUpsTotal}件）
              </Typography>
              {tossUps.length > 0 ? (
                <>
                  <Box className="dd-list" sx={{ display: "flex", flexDirection: "column", gap: "var(--sp-1)" }}>
                    {tossUps.slice(0, 3).map((row, i) => (
                      <Box
                        key={i}
                        className="dd-row"
                        component={Link}
                        to="/toss_up"
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: "var(--sp-2)",
                          p: "var(--sp-1) var(--sp-2)",
                          border: "1px solid var(--color-border)",
                          borderRadius: "var(--radius-sm)",
                          fontSize: "var(--fs-12)",
                          cursor: "pointer",
                          "&:hover": { bgcolor: "action.hover" },
                          textDecoration: "none",
                          color: "inherit",
                        }}
                      >
                        <Typography component="span" className="dd-nm" sx={{ fontWeight: "var(--fw-semibold)", color: "var(--color-sumi)", flex: 1, fontSize: "var(--fs-12)" }}>
                          {String(row.customer_name ?? row.customer_phone_number ?? "")}
                        </Typography>
                        <Typography component="span" className="dd-pd" sx={{ color: "var(--color-sumi-light)", fontSize: "var(--fs-11)", flexShrink: 0 }}>
                          架電希望: {String(row.hope_call_time ?? "")}
                        </Typography>
                        <ChevronRightIcon sx={{ fontSize: 14, color: "text.disabled", flexShrink: 0 }} />
                      </Box>
                    ))}
                  </Box>
                  {tossUpsTotal > 3 && (
                    <Typography component="span" className="po-helper" sx={{ fontSize: "var(--fs-11)", color: "var(--color-sumi-muted)" }}>
                      ほか{tossUpsTotal - 3}件
                    </Typography>
                  )}
                </>
              ) : (
                <Typography sx={{ fontSize: "var(--fs-12)", color: "text.secondary" }}>
                  {tossUpsTotal === 0 && !hasHopeCallDateSearch
                    ? "架電希望日の検索はテナント設定で無効です"
                    : "該当なし"}
                </Typography>
              )}
            </Box>
          </>
        ) : (
          <Typography color="textSecondary" sx={{ py: 2 }}>
            データなし
          </Typography>
        )}
    </PoModalShell>
  );
}
